angular
    .module("skillBuilderSaaS")
    .filter("sbSubstring", function () {
    return function (text, charsToShow) {
        return text ? (text.length > charsToShow ? text.substr(0, charsToShow) : text) : "";
    };
});
